module.exports = __webpack_public_path__ + "media/store/images/logoNavbar-d392163b1bd49afd36f395968bee2a34.svg";